import React from "react";
import { NavItem, NavLink, NavTitle } from "./styles";

export default function NavigationItem({ icon, title, url, onClick }) {
  return (
    <NavItem>
      <NavLink to={url} title={title} onClick={onClick}>
        {icon} <NavTitle>{title}</NavTitle>
      </NavLink>
    </NavItem>
  );
}
